import MembershiptypesDashboardDiagrams from './membershipcategories-dashboard-diagrams';
export default MembershiptypesDashboardDiagrams;
